const defaultChipStyles = {
  fontWeight: 500,
  letterSpacing: '0.5px'
};

export default defaultChipStyles;
